import styled, { css } from 'styled-components';

import { Colour } from '@xemplo/colours';
import { DawnArrowDown } from '@xemplo/icons';
import {
  inputContainerStateStyles,
  inputContainerStyles,
  inputFocus,
  InputSize,
} from '@xemplo/input-utils';
import { zIndex } from '@xemplo/zindex';

const straightenBorders = css`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const TriggerElementWrapper = styled.div`
  ${inputContainerStyles};
  ${inputContainerStateStyles};
  ${straightenBorders};
  --input-width: 80px;
  border-right: none;
  flex-shrink: 0;
  padding: 0 16px;

  &.${InputSize.Spacious} {
    --input-height: 64px;
  }

  &.${InputSize.Default} {
    --input-height: 48px;
  }

  &.${InputSize.Compact} {
    --input-height: 40px;
  }

  &.open {
    ${inputFocus};
    ${straightenBorders};
    border-right: 1px solid var(--input-border-color);
    z-index: ${zIndex.FormField};

    & > .arrow {
      transform: rotate(180deg);
    }
  }
`;

export const Arrow = styled(DawnArrowDown)`
  transition: transform 0.2s ease-out;
  font-size: 16px;
  color: ${Colour.Gray[400]};
`;
